/*
 * @Description:
 * @Author: zhanghao
 * @Date: 2024-09-18 11:15:52
 * @LastEditTime: 2025-10-20 16:53:36
 * @LastEditors: zhanghao
 */
/*
 * author: Jimmy
 * createdTime: 2018/01/18
 * */
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { Router, Route } from 'react-router-dom';
import { history } from '@RouterAdmin';
import stores from './redux/store';
import './base.less';
import routes from './router/router';
import { LocaleProvider } from 'antd';
import * as Sentry from '@sentry/react';
import zhCN from 'antd/lib/locale-provider/zh_CN';
import 'moment/locale/zh-cn';
// import {AppContainer} from 'react-hot-loader'
import { getData } from '@util';

/* zero 添加 ant design pro 样式 */
import 'ant-design-pro/dist/ant-design-pro.css';
import { getVariant, hasVariant } from '@Variant';
import { setBaseUrl, setRequest, setStatInfo, setErrorTip, RaFeat, RaProvider } from 'radish';
import { setRequest as cocozelleSetRequest } from 'cocozelle';

process.env.NODE_ENV !== 'development' &&
  Sentry.init({
    dsn: 'https://121b90ffacf34ad590f73fa8e301bbb3@appsentry.freshfood.cn/73',
    environment: process.env.NODE_ENV,
    denyUrls: ['cqxcbb', 'maoyinews', 'hunong', 'itaozi', 'clink', 'vvipquan'],
    // 轮询接口报错太频繁给忽略掉
    ignoreErrors: [
      'Failed to fetch',
      '同一个请求还没有返回之前',
      '请求时间超过600000',
      '网络连接已中断。',
      'Load failed',
      'NetworkError when attempting to fetch resource',
      '服务繁忙，请稍等刷新重试',
      '下载队列繁忙，请稍后重试',
      'window.uc_',
      'ResizeObserver loop limit exceeded',
      '160100005',
      'ResizeObserver loop completed with undelivered notifications',
      "null is not an object (evaluating 'ifameElement.contentDocument.addEventListener')",
      '无法连接服务器。',
      '似乎已断开与互联网的连接。',
      'RequestError',
      'Failed to fetch',
      // 百度地图上报屏蔽
      "Failed to execute 'shaderSource' on 'WebGLRenderingContext': parameter 1 is not of type 'WebGLShader'.",
      "Cannot set properties of null (setting 'width')",
      "Cannot read properties of null (reading 'clientWidth')",
      "Cannot read property 'clientWidth' of null",
      "Cannot set property 'width' of null",
      "Cannot read properties of undefined (reading 'markerArr')",
      "NetworkError: Failed to execute 'importScripts' on 'WorkerGlobalScope': The script at 'http://api.map.baidu.com/res/webgl/10/worker_wasm_cimp12.js' failed to load",
      "NetworkError: Failed to execute 'importScripts' on 'WorkerGlobalScope': The script at 'http://api.map.baidu.com",
      "Cannot read properties of null (reading 'data:image/png;base64,",
      'i.slice is not a function',
      'BMap',
      'BMapGL.Point is not a constructor',
      "Failed to execute 'removeEventListener'",
      "Cannot read properties of undefined (reading 'clearData')",
      "Cannot read properties of null (reading 'takeAction')",
      "Cannot read property 'length' of null",
      "Cannot read properties of null (reading 'x')",
      "Cannot read properties of null (reading 'isExitTileLayer')",
      "undefined is not an object (evaluating 'webkit.messageHandlers.loginsManagerMessageHandler.postMessage')",
    ],
    beforeSend: event => {
      // 检查错误堆栈中是否存在百度地图相关的URL或特征字符串
      if (event.exception && event.exception.values) {
        for (const exception of event.exception.values) {
          if (exception.stacktrace && exception.stacktrace.frames) {
            for (const frame of exception.stacktrace.frames) {
              if (frame.filename && frame.filename.includes('map.baidu.com')) {
                return null; // 过滤百度地图URL相关的错误
              }
            }
          }
        }
      }

      // 新增：检查extra.arguments中是否包含.BMapLabel
      if (event.extra && event.extra.arguments) {
        for (const arg of event.extra.arguments) {
          if (arg.currentTarget && arg.currentTarget.includes('.BMap')) {
            return null; // 过滤包含.BMapLabel的错误
          }
          if (arg.target && arg.target.includes('.BMap')) {
            return null; // 过滤包含.BMapLabel的错误
          }
        }
      }
      // 获取 User Agent
      const userAgent = navigator.userAgent || navigator.vendor || window.opera;

      // 定义兼容大小写和空格的规则（核心改动）
      const blockedBrowsers = [
        /QQ[\s-]*Browser/gi,
        /UC[\s-]*Browser/gi,
        /Quark/gi,
        /Edge/gi,
        /MetaSr/gi, // 搜狗浏览器
        /LBBROWSER/gi, // 猎豹浏览器
        /Maxthon/gi, // 傲游浏览器
        /Chrome[\s-]*Mobile/gi,
        /Mobile[\s-]*Safari/gi,
        /[\s-]*Mobile[\s-]*WebView/gi, // 任意移动浏览器
      ];
      // 检查是否匹配要忽略的浏览器
      const isBlocked = blockedBrowsers.some(regex => regex.test(userAgent));

      // 如果匹配，返回 null 丢弃事件
      if (isBlocked) {
        return null;
      }

      // 否则正常上报
      return event;
    },
    release: process.env.SENTRY_RELEASE_NAME,
    integrations: [
      new Sentry.Integrations.GlobalHandlers({
        onerror: true,
        onunhandledrejection: false,
      }),
    ],
  });

const userInfo = hasVariant('userInfos') ? JSON.parse(getVariant('userInfos')) : {};
Sentry.configureScope(scope => {
  scope.setUser({
    id: userInfo?.telephone,
    username: userInfo?.username,
    uid: userInfo?.id,
  });
});

const requestTransformer = function (options) {
  console.log('options is', options);
  let lastUrl = options.url;
  const { paramsType, data } = options;
  const method = (
    options.method ||
    options.options?.method ||
    options.config?.method ||
    'GET'
  ).toLocaleUpperCase();

  if (method === 'GET' || method === 'DELETE' || method === 'HEAD' || method === 'OPTIONS') {
    const [pathname, query] = lastUrl.split('?');
    const lastParams = new URLSearchParams();

    if (query) {
      const queryParams = new URLSearchParams(query);
      queryParams.forEach((value, key) => {
        lastParams.append(key, value);
      });
    }
    if (options.data) {
      const dataParams = new URLSearchParams(options.data);
      dataParams.forEach((value, key) => {
        lastParams.append(key, value);
      });
    }

    if (lastParams) {
      lastUrl = pathname + '?' + lastParams?.toString();
    }

    if (Reflect.has(options, 'body')) {
      Reflect.deleteProperty(options, 'body');
    }
    if (Reflect.has(options, 'data')) {
      Reflect.deleteProperty(options, 'data');
    }
  } else if (method === 'POST' || method === 'PATCH' || method === 'PUT') {
    options.body = options.body || options.data;
    if (typeof options.body === 'object') {
      options.body = JSON.stringify(options.body);
    }
    options.headers = {
      'Content-Type': 'application/json;charset=UTF-8',
      ...options.headers,
    };
  }

  if (paramsType === 'query' && method !== 'GET' && data) {
    if (!lastUrl.includes('?')) {
      lastUrl += '?1=1';
    }
    Object.keys(data).forEach(key => {
      lastUrl += `&${key}=${data[key]}`;
    });
  }

  if (options?.headers?.['Content-Type'] === 'multipart/form-data') {
    const newData = new FormData();
    delete options.headers['Content-Type'];

    Object.entries(options.data).forEach(([key, value]) => {
      if (Array.isArray(value)) {
        value.forEach(item => {
          newData.append(key, item);
        });
      } else {
        newData.append(key, value);
      }
    });
    options.data = newData;
  }

  const lastHost = options.host || options.options?.host || 'SUPPLIER';
  return getData({
    api: {
      url: lastUrl,
      config: {
        method: method,
        host: lastHost,
        noWarn: options?.noWarn || options.options?.noWarn,
      },
    },
    ...options,
  });
};

history.listen(() => {
  RaFeat.updateFeatList();
});

setBaseUrl('');

setRequest(requestTransformer);

cocozelleSetRequest(requestTransformer);
setErrorTip(error => {
  console.log('error is', error);
});

setStatInfo({
  //项目名
  projectName: 'scc',
  //间隔时间上报，默认10s
  interval: 1000000,
  //上报地址
  statUrl: 'http://dev.data.b2bcsx.com:10087/api/component-stat/report',
});

const env = process.env.NODE_ENV || 'prod';
// devops特性开关环境映射
const envMap = {
  DEV: '1',
  DEVELOPMENT: '1',
  TEST: '1',
  SIT: '2',
  PRE: '3',
  PROD: '4',
  PRODUCTION: '4',
};
const featEnv = envMap[env.toLocaleUpperCase()];

ReactDOM.render(
  <RaProvider
    // value={{}}
    feat={{
      url: 'devops-v1/devops/txSwitch2C/queryByProject',
      reqData: {
        env: featEnv,
        projectId: 360, //北极星数据中心前端项目id
        type: 1, //前端
      },
      reqOptions: {
        host: 'DEVOPS',
      },
    }}>
    <Provider store={stores}>
      <LocaleProvider locale={zhCN}>
        <Router history={history}>
          <Route path="/" component={routes} />
        </Router>
      </LocaleProvider>
    </Provider>
  </RaProvider>,
  document.getElementById('root'),
);
window.addEventListener('error', function (e) {
  if (e.message.includes('clientLeft')) {
    console.log('clientLeft错误详情:', e);
    console.log('错误来源:', e.filename);
    Sentry.captureMessage(e);
  }
});
